export const theme = {
  colors: {
    primary: '#1db954', // Spotify green
    secondary: '#1ed760',
    accent: '#ff6b6b',
    background: {
      primary: '#121212',
      secondary: '#181818',
      tertiary: '#282828',
      card: '#1a1a1a',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b3b3b3',
      tertiary: '#666666',
    },
    border: '#333333',
    success: '#1db954',
    error: '#e22134',
    warning: '#ffa500',
  },
  
  gradients: {
    primary: 'linear-gradient(135deg, #1db954 0%, #1ed760 100%)',
    background: 'linear-gradient(135deg, #121212 0%, #181818 100%)',
    card: 'linear-gradient(135deg, #1a1a1a 0%, #252525 100%)',
  },
  
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.3)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.4)',
    large: '0 8px 16px rgba(0, 0, 0, 0.5)',
    glow: '0 0 20px rgba(29, 185, 84, 0.3)',
  },
  
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    full: '50%',
  },
  
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  
  typography: {
    fontFamily: {
      primary: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      mono: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      xxl: '1.5rem',
      xxxl: '2rem',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },
  
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    large: '1200px',
  },
  
  transitions: {
    fast: '0.15s ease-out',
    normal: '0.3s ease-out',
    slow: '0.5s ease-out',
  },
  
  zIndex: {
    dropdown: 1000,
    modal: 1100,
    tooltip: 1200,
    toast: 1300,
  },
}; 